<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="linha-produto vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t('linhas-produto') }}
                            </h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            isVenda ? $t('vendas') : $t('promotor')
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            isVenda ? $t('produto') : $t('cadastros')
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('linhas-produto') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !linhaIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: isVenda ? 'ven-produto-linha-new' : 'new-linha',
                                    })
                                "
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-half">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>

                        <!-- SUBGRUPOS -->
                        <div class="situacao-select column is-one-quarter">
                            <vss-select
                                ref="subGrupoSelect"
                                :options="subgrupos"
                                v-model="subgrupo"
                                class="no-clear"
                                title="subgrupoproduto"
                                :height="40"
                                @input="carregarDados('')"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{ $t('sem-resultados') }}</template>
                            </v-select>
                        </div>
                    </div>

                    <div class="linha-produto-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="alllps"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="updateSort"
                            backend-sorting
                            backend-pagination
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key != 'excluir' ? $t(f.key) : ''"
                                :width="f.width"
                                :class="f.key != 'excluir' ? '' : 'excluir-field'"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'excluir'">
                                    <b-button
                                        v-if="permissao.delete && !linhaIntegracao"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        @click="confirmExclusion(props.row)"
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        position="is-left"
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>
                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: isVenda ? 'ven-produto-linha-edit' : 'edit-linha',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'subgrupoproduto'">
                                    <pre>{{ props.row[f.key] }}</pre>
                                </div>
                                <div v-else-if="f.key == 'grupoproduto'">
                                    <pre>{{ props.row[f.key] }}</pre>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-if="props.row[f.key] == 1"
                                        type="is-success"
                                        size="is-medium"
                                        >{{ $t('ativo') }}
                                    </b-tag>
                                    <b-tag
                                        class="table-tag table-tag-full-width"
                                        v-else
                                        type="is-danger"
                                        size="is-medium"
                                        >{{ $t('inativo') }}
                                    </b-tag>
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import LinhaProdutoService from '@/services/LinhaProdutoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            ['ven-produto-linha-new', 'ven-produto-linha-edit', 'new-linha', 'edit-linha'].includes(
                to.name
            )
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            linhaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('LINHAPRODUTO'),
            alllps: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            service: new LinhaProdutoService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: '10%', sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                {
                    key: 'subgrupoproduto',
                    width: null,
                    sortable: false,
                    sortFn: null,
                },
                {
                    key: 'grupoproduto',
                    width: null,
                    sortable: false,
                    sortFn: null,
                },
                { key: 'situacao', width: 80, sortable: false, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            queryFilter: '',
            changeThis: {},
            sort: 'data',
            order: 'asc',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            // @84562 - Criação da variável para verificar a origem da rota;
            // Esta variável é utilizada sempre que for necessário verificar se a origem é vendas ou promotor
            isVenda: 'vendas' === this.$route.meta.contexto,
            // @84562 - Criação de variáveis para obter os subgrupos do combo
            subgrupos: [],
            subgrupo: { id: 0, label: this.$t('todos').toUpperCase() },
            combo: [],
            empresas: [],
        };
    },
    created() {
        if (
            ['ven-produto-linha-new', 'ven-produto-linha-edit', 'new-linha', 'edit-linha'].includes(
                this.$route.name
            )
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.isVenda
            ? this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-linha')
            : this.hasPermissionAccess('promotor', 'cadastros', 'linhas');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'linhas-produto' },
            });
        } else {
            this.loadEmpresasId();
            this.loadComboSubGrupo('');
        }
    },
    methods: {
        // @84562 - Carregar empresas que o usuário tem vínculo
        loadEmpresasId() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            }
        },
        filterComboSubGrupo(search) {
            this.combo = this.subgrupos.filter((e) => {
                return e.descricao.toLocaleUpperCase().includes(search.toLocaleUpperCase());
            });
        },
        // @84562 - Carrega o combo do subgrupo
        loadComboSubGrupo(search) {
            let empresas = '0, ';
            for (let e of this.empresas) {
                empresas += `${e.id}, `;
            }
            empresas = empresas.slice(0, -2);
            this.service
                .loadComboSubGrupo(empresas, search)
                .then((body) => {
                    this.subgrupos = [];
                    if (search === '') {
                        let subgrupo = {
                            id: 0,
                            label: this.$t('todos').toUpperCase(),
                        };
                        this.subgrupos.push(subgrupo);
                    }
                    body.content.map((r) => {
                        let subgrupo = { id: r.id, label: r.descricao };
                        this.subgrupos.push(subgrupo);
                    });
                    this.subgrupos.sort();
                    this.combo = this.subgrupos;
                    this.subgrupo = this.subgrupos[0];
                }, 350)
                .finally((_) => {
                    this.carregarDados();
                });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        updateSort(sort, order) {
            this.sort = sort;
            this.order = order;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            let subgrupo = '';
            if (this.subgrupo.id === 0) {
                for (let g of this.subgrupos) {
                    subgrupo += `${g.id}, `;
                }
                subgrupo = subgrupo.slice(0, -2);
            } else {
                subgrupo = this.subgrupo.id;
            }
            this.isLoading = true;
            this.service
                .findAll(
                    this.sort,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    subgrupo,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.alllps = value;
                    this.isEmpty = this.alllps.length <= 0;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        onSituacaoChanged(situacao) {
            this.situacao = situacao;
            this.carregarDados();
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let lplist = [];
            if (body.content) {
                lplist = body.content.map((lp) => {
                    return {
                        id: lp.idlinhaproduto,
                        codigo: lp.idlinhaprodutoerp,
                        descricao: lp.descricao,
                        excluir: 'excluir-linha-produto',
                        situacao: lp.situacao,
                        subgrupoproduto: lp.subgrupoproduto.descricao,
                        grupoproduto: lp.grupoproduto.descricao,
                    };
                });
            }
            return lplist;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        confirmExclusion(item) {
            this.changeThis = item;
            this.$root.confirm({
                message:
                    item.situacao == 1
                        ? this.$t('msg-confirmacao-desativacao-n', { n: item.descricao })
                        : this.$t('msg-confirmacao-reativacao-n', { n: item.descricao }),
                onConfirm: this.changeSituacao,
                onCancel: (_) => {
                    this.changeThis = null;
                },
            });
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        changeSituacao() {
            let item = { idlinhaproduto: this.changeThis.id, situacao: this.changeThis.situacao };
            this.isLoading = true;
            this.service
                .changeSituacao(item)
                .then((_) => {
                    if (item.situacao == 1) {
                        this.$root.showMessage('success', 'msg-sucesso-ao-desativar-linhaproduto');
                    } else {
                        this.$root.showMessage('success', 'msg-sucesso-ao-reativar-linhaproduto');
                    }
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error('Erro ao excluir linha.', e);
                    if (item.situacao == 0) {
                        this.$root.showMessage('error', 'msg-erro-ao-desativar-linhaproduto');
                    } else {
                        this.$root.showMessage('error', 'msg-erro-ao-reativar-linhaproduto');
                    }
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.changeThis = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }

    .linha-produto .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .linha-produto .search-and-filter {
        .search-bar {
            width: 80%;
        }
        .item-input {
            width: 19%;
            > .v-select {
                height: 38px;
            }
        }
    }

    .linha-produto .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
